export default __webpack_public_path__ + "static/media/ic-instruction-04.dd75c663.svg";